/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'https://commenting-tool-demo-api-v2.geodemosolutions.com/public/'
  // appBaseUrl = 'https://commenting-tool-demo-v2.geodemosolutions.com/#/'
  baseApiUrl = 'https://drive-easy-commenting-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://drive-easy-commenting-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/driveeasycommentingtoolapi/public/'
  appBaseUrl = 'http://localhost:5900/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
